export default __webpack_public_path__ + "static/zach overcash-f39ce77d170d5ebc8ffc84bf37a0b215.png";